(function () {
  const params =
    new URLSearchParams(
      window.location.search
    );

  if (
    params.get('dsh-series') !== '1'
  ) {
    return;
  }

  const STORAGE_KEY =
    'adena365:dsh-series-inquiry:v1';

  let inquiry = null;

  try {
    const raw =
      window.localStorage.getItem(
        STORAGE_KEY
      );

    inquiry =
      raw
        ? JSON.parse(raw)
        : null;
  } catch (error) {
    inquiry = null;
  }

  if (!inquiry) {
    return;
  }

  const form =
    document.querySelector(
      'form.contact-form__form'
    );

  const body =
    form?.querySelector(
      'textarea[name="contact[body]"]'
    );

  if (!form || !body) {
    return;
  }

  function num(value) {
    return Number(value)
      .toLocaleString(
        'de-DE',
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      );
  }

  const d =
    inquiry.dimensions || {};

  const dimensionText =
    'AD ' +
    num(d.outerDiameterMm) +
    ' mm × ID ' +
    num(d.innerDiameterMm) +
    ' mm × ' +
    (inquiry.dimensionCode || 'H/L') +
    ' ' +
    num(d.thirdDimensionMm) +
    ' mm';

  const message = [
    'Serienanfrage technische Kunststoffteile',
    '',
    'Bauteil: ' + (inquiry.productName || ''),
    'Maße: ' + dimensionText,
    'Material: ' + (inquiry.material?.name || ''),
    'Farbe: ' + (inquiry.color?.name || ''),
    'Menge: ' + inquiry.quantity + ' Stück',
    'Prüfung: ' + (inquiry.productionReview || 'Serienfertigung prüfen'),
    '',
    'Bitte prüfen Sie das wirtschaftlichste Fertigungsverfahren und senden Sie mir ein Angebot.'
  ].join('\n');

  body.value = message;

  let subject =
    form.querySelector(
      'input[name="contact[subject]"]'
    );

  if (!subject) {
    subject =
      document.createElement(
        'input'
      );

    subject.type = 'hidden';
    subject.name = 'contact[subject]';
    form.appendChild(subject);
  }

  subject.value =
    'Serienanfrage ' +
    (inquiry.productName || 'Kunststoffteil') +
    ' – ' +
    inquiry.quantity +
    ' Stück';

  const notice =
    document.createElement(
      'div'
    );

  notice.className =
    'dsh-series-inquiry-notice';

  notice.textContent =
    'Deine Konfiguration wurde aus dem Konfigurator übernommen. Ergänze bitte nur noch deine Kontaktdaten.';

  form.insertBefore(
    notice,
    form.firstChild
  );

  body.focus();
})();

